import * as React from "react";
import type { SVGProps } from "react";
export const SvgGameRematchGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5716 5.13828L14.4004 9.50721V5.13828H13.4476L7.18829 14.1619H9.54616L12.2561 10.4288V14.1619H13.5591L16.9266 9.52308V14.1619H19.1666V5.13828H17.5716Z"
      fill="#5C5C8E"
    />
    <path
      d="M6.64524 12.8054L5.36049 11.0955C6.8059 10.4442 7.36578 9.65777 7.36578 8.23208C7.36578 5.15416 4.16905 5.15416 4.16905 5.15416H0.833313V14.1619H2.89873V11.1436L4.99108 14.1619H5.84678L6.64572 12.8054H6.64524ZM4.3071 9.09403H2.89873V7.37061H4.22004C4.22004 7.37061 5.10171 7.33886 5.10171 8.14117C5.10171 8.94348 4.64091 9.09452 4.30758 9.09452L4.3071 9.09403Z"
      fill="#5C5C8E"
    />
    <path d="M11.1282 4.76888V2.40091L9.0108 6.83285L11.1282 4.76888Z" fill="#5C5C8E" />
    <path d="M8.18688 8.55772L3.62988 18.0964L15.8728 0.833332L8.18688 8.55772Z" fill="#5C5C8E" />
  </svg>
);
